import { FC } from "react";
import FormData from "../../../components/forms/FormData";
import FormError from "../../../components/forms/FormError";
import FormLabel from "../../../components/forms/FormLabel";
import FormTable from "../../../components/forms/FormTable";
import FormTr from "../../../components/forms/FormTr";
import Input from "../../../components/forms/Input";
import { ValidationErrors } from "../../../services/types";
import * as Fields from "./Fields";
import { CountryForm } from "./types";

interface NewEditTableProps {
  state: CountryForm;
  setState: React.Dispatch<React.SetStateAction<CountryForm | undefined>>;
  errors: ValidationErrors;
}

const NewEditTable: FC<NewEditTableProps> = ({ state, setState, errors }: NewEditTableProps) => {
  return (
    <FormTable>
      <FormTr>
        <FormLabel required>{Fields.code.title}</FormLabel>
        <FormData>
          <Input
            value={state.code}
            onChange={(value) =>
              setState({
                ...state,
                code: value,
              })
            }
          />
          <FormError error={errors[Fields.code.fieldName]} />
        </FormData>
      </FormTr>
      <FormTr>
        <FormLabel required>{Fields.name.title}</FormLabel>
        <FormData>
          <Input
            value={state.name}
            onChange={(value) =>
              setState({
                ...state,
                name: value,
              })
            }
          />
          <FormError error={errors[Fields.name.fieldName]} />
        </FormData>
      </FormTr>
      <FormTr>
        <FormLabel required>{Fields.phoneCode.title}</FormLabel>
        <FormData>
          <Input
            value={state.phoneCode}
            onChange={(value) =>
              setState({
                ...state,
                phoneCode: value,
              })
            }
          />
          <FormError error={errors[Fields.phoneCode.fieldName]} />
        </FormData>
      </FormTr>
    </FormTable>
  );
};

export default NewEditTable;
